import { getUserNotifications } from "@/services/notifications";
import {
  NotificationType,
  UserNotification,
} from "@/services/notifications/types/notification.types";
import { useUser } from "@/context/UserContext";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useQuery } from "react-query";

export const useNotificationButton = () => {
  const navigate = useNavigate();
  const { userInfo } = useUser();

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const isOpen = !!anchorEl;

  const [showNotificationModalId, setShowNotificationModalId] = useState(-1);
  const toggleNotificationModal = (id: number) => {
    if (showNotificationModalId === -1) {
      return setShowNotificationModalId(id);
    }

    setShowNotificationModalId(-1);
  };

  const onClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const onClose = () => {
    setAnchorEl(null);
  };

  const onClickNotification = ({ id, type, challenge }: UserNotification) => {
    if (
      type === NotificationType.CHALLENGE_STARTED ||
      type === NotificationType.INTERVIEW_SCHEDULED
    ) {
      onClose();
      return navigate("/challenges");
    }

    if (
      (type === NotificationType.CHALLENGE_APPROVED ||
        type === NotificationType.CHALLENGE_REJECTED) &&
      challenge
    ) {
      const url =
        challenge.type === "QuizChallenge"
          ? `quiz/${challenge.id}`
          : `media/${challenge.id}`;

      onClose();
      return navigate(`/challenges/${url}`);
    }

    if (type === NotificationType.NEW_COURSE) {
      onClose();
      return navigate(`/courses`);
    }

    toggleNotificationModal(id);
  };

  const {
    data: notifications,
    isLoading,
    refetch,
  } = useQuery(
    ["notifications", userInfo?.id],
    () => getUserNotifications(),
    {
      enabled: userInfo?.id != null,
      select: (d) => d ?? [],
    }
  );

  /** Ao abrir o painel, atualiza a lista (comportamento anterior do useEffect[isOpen]). */
  useEffect(() => {
    if (!isOpen || userInfo?.id == null) return;
    void refetch();
  }, [isOpen, userInfo?.id, refetch]);

  return {
    anchorEl,
    isOpen,
    onClick,
    onClose,

    isLoading,
    notifications,
    showNotificationModalId,
    toggleNotificationModal,
    onClickNotification,
  };
};
